import React from "react";
import "./Input.css";

const Input = ({
  label,
  value,
  handler,
  onFocus,
  type,
  error,
  readOnly
}: {
  label: string | React.ReactNode;
  value: string;
  handler: (text: string) => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement, Element>) => void;
  type?: `text` | `number` | "tel" | "email";
  error?: string;
  readOnly?: boolean;
}) => {
  return (
    <div className="input_wrapper ">
      {typeof label === "string" ? (
        <label className="flex med_text">{label}</label>
      ) : (
        label
      )}
      <input
        readOnly={!!readOnly}
        value={value}
        onFocus={onFocus}
        onChange={(e) => {
          const value = e.target.value;
          handler(value);
        }}
        type={type ? type : "text"}
        className={`${readOnly ? "noOutline" : ""} input_field`}
      />
      {error ? <span className="errorMsg">{error}</span> : ``}
    </div>
  );
};

export default Input;
